export default class SearchQuery {
  arrivalAirport = ''
  departureAirport = ''
  departureDate = ''
  order = ''
  route = ''
  items = []
}
